import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=4d24fe9e&"
import script from "./PersonSelect.vue?vue&type=script&lang=js&"
export * from "./PersonSelect.vue?vue&type=script&lang=js&"
import style0 from "./PersonSelect.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports